import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import Tooltip from 'components/Tooltip';
import {PermissionResponse} from 'types/permissions';

type NavigationTabsHistoryProps = NavigationTabsPropsHelper<{
    permissions: {
        preservationEnabled: PermissionResponse;
    };
}>;

const NavigationTabsHistory: FC<NavigationTabsHistoryProps> = ({
    className,
    permissions: {preservationEnabled},
    selection,
}) => {
    const {t} = useTranslation('Navigation.NavigationTabs');

    return (
        <BaseNavigationTabs className={className} selection={selection}>
            <BaseNavigationTabsButton
                href={window.Urls.history_view()}
                label={t('history.events')}
                name="events"
            />
            <BaseNavigationTabsButton
                href={window.Urls.past_order_list_view()}
                label={t('history.sendingOrders')}
                name="sendingOrders"
            />
            <BaseNavigationTabsButton
                href={window.Urls.async_download_view()}
                label={t('history.downloads')}
                name="downloads"
            />
            <Tooltip message={preservationEnabled.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!preservationEnabled.allowed}
                    href={window.Urls.preservation_list_view()}
                    label={t('history.documentArchive')}
                    name="documentArchive"
                />
            </Tooltip>
        </BaseNavigationTabs>
    );
};

export default NavigationTabsHistory;
